"use strict";
var Observable_1 = require('../../Observable');
var multicast_1 = require('../../operator/multicast');
Observable_1.Observable.prototype.multicast = multicast_1.multicast;
//# sourceMappingURL=multicast.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/multicast.js
 ** module id = 1212
 ** module chunks = 0
 **/